var React = require('react');

function LockedProfile (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"40","cy":"40","r":"40","fill":"#F5F5F5","key":0}),React.createElement("g",{"stroke":"#A9B0B7","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M28 36v-6c0-6.627 5.373-12 12-12s12 5.373 12 12v6h-4.5v-6a7.5 7.5 0 0 0-15 0v6H28z","fill":"#E2E5E7","key":0}),React.createElement("path",{"d":"M52 61H28c-1.657 0-3-1.316-3-2.941V38.94c0-1.624 1.343-2.94 3-2.94h24c1.657 0 3 1.316 3 2.941V58.06c0 1.624-1.343 2.94-3 2.94z","fill":"#FFF","key":1}),React.createElement("path",{"d":"M45 46.333C45 43.94 42.985 42 40.5 42c-2.486 0-4.5 1.94-4.5 4.333 0 1.84 1.195 3.402 2.876 4.03L37.5 55h6l-1.375-4.637c1.68-.628 2.875-2.19 2.875-4.03z","fill":"#E2E5E7","key":2})])]));
}

LockedProfile.displayName = "LockedProfile";

LockedProfile.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80"};

module.exports = LockedProfile;

LockedProfile.default = LockedProfile;



//////////////////
// WEBPACK FOOTER
// ./src/assets/locked-profile.svg
// module id = 4289
// module chunks = 14